import React, { useEffect, useRef, useState } from 'react'
import { debounce as debounceFn } from 'lodash'
import { Box, FormLabel, FormControl, FormHelperText } from '@mui/material'
import { getLabel, getComputedWidth, isValueAllowed } from './utils'
import { StyledTextArea } from './styled.js'

export const CommonTextarea = ({
  id,
  label,
  value,
  error,
  width,
  helperText,
  minRows = 4,
  fullWidth = true,
  debounce = false,
  required = false,
  debounceTime = 400,
  restrictedValues = null,
  setValue,
  onChange,
  ...muiProps
}) => {
  const isValidInput = React.useRef(true)
  const [localValue, setLocalValue] = useState(
    !isValueAllowed(value, restrictedValues) ? '' : value
  )

  useEffect(() => {
    if (isValueAllowed(value, restrictedValues)) setLocalValue(value)
    else setLocalValue('')
  }, [value, restrictedValues])

  const handleChange = newValue => {
    if (setValue) setValue(newValue)
    if (onChange) onChange(newValue)
  }

  const handleDebouncedChange = useRef(
    debounceFn(newValue => {
      handleChange(newValue)
    }, debounceTime)
  ).current

  const handleInput = event => {
    const newValue = event.target.value
    isValidInput.current = isValueAllowed(newValue, restrictedValues)
    if (!isValidInput.current) return

    setLocalValue(newValue)
    if (debounce) handleDebouncedChange(newValue)
    else handleChange(newValue)
  }

  return (
    <Box data-testid={id} sx={{ width: getComputedWidth(width, fullWidth) }}>
      <FormControl fullWidth error={!!error}>
        <FormLabel>{getLabel(label, required)}</FormLabel>
        <StyledTextArea
          id={id}
          error={error}
          minRows={minRows}
          value={localValue || ''}
          onChange={handleInput}
          {...muiProps}
        />
        {(error || helperText) && (
          <FormHelperText>{error || helperText}</FormHelperText>
        )}
      </FormControl>
    </Box>
  )
}
